// extracted by mini-css-extract-plugin
export default {"saveButton":"createFreelancerForm_saveButton__PvKTz","select":"createFreelancerForm_select__J2T4Q","input":"createFreelancerForm_input__y1HKM"};